// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__8u-cD","row":"Tooltip_row__qZ+IP","label":"Tooltip_label__SYpkS","value":"Tooltip_value__PpF-a","inputValue":"Tooltip_inputValue__XwdR8"};